export const BASE_URL = "https://admin-sbi.apps-domaware.com/"
//export const BASE_URL = "http://localhost/sbi-admin-backend/"
